import { render, staticRenderFns } from "./OTP.vue?vue&type=template&id=3b3892ba&scoped=true"
import script from "./OTP.vue?vue&type=script&lang=js"
export * from "./OTP.vue?vue&type=script&lang=js"
import style0 from "./OTP.vue?vue&type=style&index=0&id=3b3892ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3892ba",
  null
  
)

export default component.exports